<template>
  <ValidationProvider :name="$attrs.name || $attrs.label" :rules="rules">
    <v-text-field
      :disabled="$attrs.disabled"
      :error-messages="!$attrs.hideDetails ? errors : null"
      :placeholder="$attrs.placeholder"
      :success="!$attrs.hideValidations ? null : valid"
      background-color="white"
      filled
      slot-scope="{ errors, valid }"
      v-bind="filteredAttrs"
      v-model="innerValue"
      v-on="$listeners"
      v-if="!$attrs.hideLabel"
    >
    </v-text-field>
    <v-text-field
      :disabled="$attrs.disabled"
      :error-messages="!$attrs.hideDetails ? errors : null"
      :placeholder="$attrs.placeholder"
      :success="!$attrs.hideValidations ? null : valid"
      background-color="white"
      filled
      slot-scope="{ errors, valid }"
      v-bind="filteredAttrsWithoutLabel"
      v-model="innerValue"
      v-on="$listeners"
      v-else
    >
    </v-text-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

// Filtra el label para que no se pase al v-text-field
function filterAttrs(attrs, removeLabel = false) {
  if (!removeLabel) return { ...attrs };
  // eslint-disable-next-line no-unused-vars
  const { label, ...rest } = attrs;
  return rest;
}

export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    // must be included in props
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: "",
    filteredAttrs: {},
    filteredAttrsWithoutLabel: {},
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
    $attrs: {
      handler(newVal) {
        this.filteredAttrs = filterAttrs(newVal, false);
        this.filteredAttrsWithoutLabel = filterAttrs(newVal, true);
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if (this.value) this.innerValue = this.value;
    if (!this.value && this.$attrs.default) {
      this.innerValue = this.$attrs.default || "";
    }
    this.filteredAttrs = filterAttrs(this.$attrs, false);
    this.filteredAttrsWithoutLabel = filterAttrs(this.$attrs, true);
  },
};
</script>
